$(document).ready(function () {
	// $('.tabs__triggers-item').click(function (e) {
	// 	e.preventDefault();
	// 	$('.tabs__triggers-item').removeClass('active');
	// 	// $('.tabs__content-item').removeClass('active');
	// 	$(this).addClass('active');
	// 	// $($(this).attr('href')).addClass('active');
	// });

	initialiseSliders();
	$('.product__interest-cards').slick({
		slidesToShow: 4,
		infinite: false,
		slidesToScroll: 1,
		arrows: false,
		responsive: [
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 481,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			}
		]
	});
	$('.product__similar-cards').slick({
		slidesToShow: 4,
		infinite: false,
		slidesToScroll: 1,
		arrows: false,
		responsive: [
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 481,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			}
		]
	});
});

function initialiseSliders() {
	let persentForOneProduct = 100 / $('.product__small-slider').children().length;


	$('.product__big-slider').imagesLoaded(function () {
		$('.product__big-slider').slick({
			slidesToShow: 1,
			infinite: false,
			slidesToScroll: 1,
			arrows: false,
			vertical: true,
			verticalSwiping: true,
			asNavFor: '.product__small-slider',
			cssEase: 'linear',

		});
		$('.product__big-slider, .product__small-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			$('.product__progress').height(`${persentForOneProduct * (nextSlide + 1)}%`);
		});

		setTimeout(() => {
			var big_image_conainer_height = $('.product__big-slider').height();
			$('.product__progress-bar').height(big_image_conainer_height);
			$('.product__progress').height(`${persentForOneProduct}%`);
			$('.product__small-slider').height(big_image_conainer_height);

		}, 100);

	});
	$('.product__small-slider').slick({
		vertical: true,
		useTransform: false,
		slidesToShow: 10,
		slidesToScroll: 1,
		asNavFor: '.product__big-slider',
		arrows: false,
		dots: false,
		focusOnSelect: true,
		infinite: false,

	});
	$('.product__big-slider').on('wheel', (function (e) {
		e.preventDefault();

		if (e.originalEvent.deltaY > 0) {
			$(this).slick('slickNext');
			$('.product__big-slider').bind('mousewheel DOMMouseScroll', function (e) { return false; });
			setTimeout(()=>{
				$('.product__big-slider').bind('m ousewheel DOMMouseScroll', function (e) { return true; });
			},300)
		} else {
			$(this).slick('slickPrev');
		}
	}));

}

// $(document).on('click', '.js-select-size', function () {
// 	console.log($(this));
// });


